import { render } from "./Pagamento.vue?vue&type=template&id=2b97dd03&scoped=true"
import script from "./Pagamento.vue?vue&type=script&lang=js"
export * from "./Pagamento.vue?vue&type=script&lang=js"

import "./Pagamento.vue?vue&type=style&index=0&id=2b97dd03&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b97dd03"]])

export default __exports__